/** CoStar.Api.AptsReviews.ViewModels.Source.ModerationStatus */
export var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus[ModerationStatus["Unknown"] = 0] = "Unknown";
    ModerationStatus[ModerationStatus["Pending"] = 10] = "Pending";
    ModerationStatus[ModerationStatus["Approved"] = 20] = "Approved";
    ModerationStatus[ModerationStatus["Rejected"] = 30] = "Rejected";
})(ModerationStatus || (ModerationStatus = {}));
/** CoStar.Api.AptsReviews.ViewModels.Source.TranslationSource */
export var TranslationSource;
(function (TranslationSource) {
    TranslationSource[TranslationSource["Unknown"] = 0] = "Unknown";
    TranslationSource[TranslationSource["HumanUser"] = 1] = "HumanUser";
    TranslationSource[TranslationSource["HumanVendor"] = 2] = "HumanVendor";
    TranslationSource[TranslationSource["Machine"] = 3] = "Machine";
})(TranslationSource || (TranslationSource = {}));
/** CoStar.Api.AptsReviews.ViewModels.Source.SourceType */
export var SourceType;
(function (SourceType) {
    SourceType[SourceType["None"] = 0] = "None";
    SourceType[SourceType["User"] = 1] = "User";
    SourceType[SourceType["Vendor"] = 2] = "Vendor";
    SourceType[SourceType["Summary"] = 3] = "Summary";
})(SourceType || (SourceType = {}));
/** CoStar.Api.AptsReviews.ViewModels.Source.ReviewCreateResponseType */
export var ReviewCreateResponseType;
(function (ReviewCreateResponseType) {
    ReviewCreateResponseType[ReviewCreateResponseType["Success"] = 0] = "Success";
    ReviewCreateResponseType[ReviewCreateResponseType["UnknownFailure"] = 1] = "UnknownFailure";
    ReviewCreateResponseType[ReviewCreateResponseType["ResidenceIdLookupFailure"] = 2] = "ResidenceIdLookupFailure";
    ReviewCreateResponseType[ReviewCreateResponseType["ReviewExists"] = 3] = "ReviewExists";
})(ReviewCreateResponseType || (ReviewCreateResponseType = {}));
/** CoStar.Api.AptsReviews.ViewModels.Source.ModerationStatusFilter */
export var ModerationStatusFilter;
(function (ModerationStatusFilter) {
    ModerationStatusFilter[ModerationStatusFilter["None"] = 0] = "None";
    ModerationStatusFilter[ModerationStatusFilter["Pending"] = 1] = "Pending";
    ModerationStatusFilter[ModerationStatusFilter["Approved"] = 2] = "Approved";
    ModerationStatusFilter[ModerationStatusFilter["Rejected"] = 4] = "Rejected";
})(ModerationStatusFilter || (ModerationStatusFilter = {}));
/** CoStar.Api.AptsReviews.ViewModels.Source.SearchType */
export var SearchType;
(function (SearchType) {
    SearchType[SearchType["Unknown"] = 0] = "Unknown";
    SearchType[SearchType["ListingId"] = 1] = "ListingId";
    SearchType[SearchType["PropertyId"] = 2] = "PropertyId";
    SearchType[SearchType["HeadquartersId"] = 3] = "HeadquartersId";
    SearchType[SearchType["ReviewId"] = 4] = "ReviewId";
    SearchType[SearchType["Content"] = 5] = "Content";
})(SearchType || (SearchType = {}));
import { SortBy } from "../../../../../CoStar/Api/AptsReviews/ViewModels/Moderation/index.js";
/** CoStar.Api.AptsReviews.ViewModels.Source.SortBy */
export { SortBy };
import { SortDirection } from "../../../../../CoStar/Api/AptsReviews/ViewModels/Moderation/index.js";
/** CoStar.Api.AptsReviews.ViewModels.Source.SortDirection */
export { SortDirection };
